import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="white_papers" />;

export const Route = createFileRoute("/es/downloads/$slug")({
  loader: ({ params }) => loadContentMeta("white_papers", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/downloads/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

